import * as PIXI from 'pixi.js';
//プラグインの読み込み
import 'pixi-picture';
import {TimelineMax} from "gsap";

export class TimelinePlus {
	constructor() {

	}

	static serial(...t):TimelineMax {
		var i, len, tl;
	
		tl = new TimelineMax();
	
		len = arguments.length;
		for (i=0;i<len;i++) {
			tl.add(arguments[i]);
		}
		return tl;
	}
	
	// ---------- parallel
	static parallel(...t):TimelineMax {
		// argumentsを直接addしたら、なんかエラー出たのでコピー
		var args = Array.prototype.slice.call(arguments, 0);
		var tl = new TimelineMax();
		tl.add(args);
		return tl;
	}

}